<!--
 * @Author: hfxie
 * @Date: 2022-08-30 16:30:40
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-12-01 17:24:57
 * @Description: 单个分类区块·左侧·行
-->
<template>
  <div class="zone-row-left">
    <!-- 支持拖拽 @dragend="DragEnd($event)" -->
    <div
      :draggable="row.draggable"
      @dragstart="Dragstart(row, $event)"
      class="zone-row"
      :style="{
        ...levelCss,
        'color': (row.color || ''),
        'padding-right': (row.rightWord? '14px': ''),
      }"
      @contextmenu.prevent.stop="ContextmenuHandle($event, row)"
    >
      <i
        class="zone-icon"
        :class="{
          'el-icon-caret-bottom': row.isExpand,
          'el-icon-caret-right': !row.isExpand,
        }"
        @click.stop="ChangeExpandRow(block, row)"
      ></i>
      <span
        :style="{
          'font-weight': row.nameBold? 'bold': '',
          'font-size': row.nameFontSize,
        }"
      >{{row.name}}</span>
      <!-- 行右侧图标 -->
      <div
        v-if="row.rightWord"
        class="right-word"
        :style="{
          'color': row.rightWordColor,
        }"
      >{{ row.rightWord }}</div>
      <!-- 操作项 -->
      <div
        v-if="row.isAddTempClass"
        class="btn-add"
        @click.stop="Add(row)"
      >
        <i class="zone-icon el-icon-circle-plus"></i>
      </div>

    </div>

    <!-- 详情 -->
    <div
      class="zone-detail"
      v-if="row.isExpand && detailsMap && detailsMap[row.detailId] && detailsMap[row.detailId].length > 0"

    >

      <div
        class="zone-detail-box"
        :style="{
          'height': detailsMap[row.detailId].length * 24 + 8 + 'px',
        }"
      ></div>


      <!-- 详情内容 -->
      <!-- <div
        class="zone-detail-box"
        :style="{
          'width': $store.state.local.totalWidth - 10 + 'px',
          'padding-left': row.level * 8 + 32 + 'px',
        }"
      >
        <template v-for="detailRow in detailsMap[row.detailId]">
          <div
            class="zone-detail-item"
            :key="'detail-' + detailRow.id"
          >
            {{detailRow.value + "  " + detailRow.label}}
          </div>
        </template>
      </div> -->

    </div>

    <!-- 子集 -->
    <template v-if="row.isExpand && row.child && row.child.length > 0">
      <template v-for="child in row.child">
        <ZoneRowLeft :key="'row-' + child.id" :block="block" :row="child" />
      </template>
    </template>

  </div>
</template>

<script>

import ZoneRowLeft from "@/components/List/Zone/Left/ZoneRowLeft";
export default {
  name: "ZoneRowLeft",
  data() {
    return {

    };
  },
  props: {
    block: {
      type: Object,
      default: () => {
        return {};
      },
    },
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },

  },
  components: {
    ZoneRowLeft,
  },
  computed: {
    levelCss() {
      // console.log(this.row);
      const level = this.row.level || 0;
      const result = {
        "padding-left": level * 8 + 12 + "px",
      };
      return result;
    },
    detailsMap() {
      return this.$store.state.data.detailsMap || {};
    },
  },
  methods: {
    ChangeExpandRow(zone, row) {
      // console.log("折叠行", row.name, zone, row, this.$outConst);
      // row.isExpand = !row.isExpand;
      this.$store.commit(
        "set_rowExpand",
        {
          zone,
          row,
        },
      );
      this.$store._invoke(this.$outConst.UPDATE_EXPAND, row);
    },
    Dragstart(dragItem, e) {
      console.log("0.拖拽开始: ");
      const _dragInfo = {
        dragItem,
        dragIndex: -1,
      };
      e.dataTransfer.setData("dragInfo", JSON.stringify(_dragInfo));
    },
    DragEnd(e) {
      console.log("3.拖拽结束: ");
    },
    Add(row) {
      this.$store.dispatch(this.$outConst.OPT_ADD, row);
    },
    formatMenus(item, menuArr) {
      const _menus = [];
      if (menuArr instanceof Array && menuArr.length > 0) {
        const _self = this;
        for (let index = 0; index < menuArr.length; index++) {
          const element = menuArr[index];
          element.label = element.cbName;
          if (element.children instanceof Array && element.children.length > 0) {
            this.formatMenus(item, element.children);
          } else {
            element.onClick = () => {
              _self.$store._invoke(element.cbNumber, item);
            };
            delete element.children;
          }
          _menus.push(element);
        }
      }
      return _menus;
    },
    ContextmenuHandle(event, item) {
      const menus1 = [
        {
          cbName: "示例示例11",
          // cbNumber: "cbNumber1",
          divided: false,
          children: [
            {
              cbName: "示例1-1",
              cbNumber: "cbNumber1-1",
              divided: true,
              children: "1111",
            },
          ],
        },
        {
          cbName: "示例2",
          // cbNumber: "cbNumber2",
          divided: false,
          children: [
            {
              cbName: "示例2-1",
              cbNumber: "cbNumber2-1",
              // divided: true,
              children: [
                {
                  cbName: "示例2-1-1",
                  cbNumber: "cbNumber2-1-1",
                  divided: true,
                  children: 1111,
                },
                {
                  cbName: "示例2-1-2",
                  cbNumber: "cbNumber2-1-2",
                  divided: true,
                  children: [],
                },
              ],
            },
          ],
        },
        {
          cbName: "示例3", // 名称
          cbNumber: "cbNumber3", // 点击对应调用服务端接口名称(参数为被点击的目标)
          divided: false, // 下划分割线
          disabled: false, // 禁用
          hidden: false, // 隐藏
        },
      ];
      const menus = item.menus;
      const items = this.formatMenus(item, menus);
      if (items.length > 0) {
        this.$contextmenu({
          items,
          event,
          customClass: "custom-class-hfx",
          zIndex: 5000,
          minWidth: 110,
        });
      }
    },

  },
};
</script>
<style scoped lang='less'>
  .zone-row-left{
    .zone-title, .zone-row{
      .text-oneline;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      padding-left: 12px;
      color: #212121;
      font-weight: 400;
      position: relative;
      .zone-icon{
        color: #666666;
        margin-right: 4px;
        font-size: 14px;
        cursor: pointer;
      };
      .zone-icon,span{
        vertical-align: middle;
      }
      &:hover .btn-add{
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
        text-align: center;
        width: 14px;
        height: 100%;
        line-height: 32px;
        background-color: #fff;
        .zone-icon{
          font-size: 14px;
        }
      }
      .right-word{
        position: absolute;
        right: 0;
        top: 0;
        text-align: center;
        display: inline-block;
        width: 14px;
        height: 100%;
        line-height: 34px;
        color: red;
      }
    }
    .zone-row{
      background: #FFFFFF;
    }
    .zone-title{
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      font-weight: 600;
    }
    .zone-detail{
      width: 100%;
      position: relative;
      background-color: @cDetail;
      font-weight: 400;
      .zone-detail-box{
        min-width: @minContentWidth;
        height: auto;
        color: #666666;
        box-sizing: border-box;
        padding: 4px 32px;
        .zone-detail-item{
          .text-oneline;
          height: 24px;
          line-height: 24px;
        }
      }

    }
    // 固定表头
    .zone-detail{
      // background: initial;
      width: 0px;
      .zone-detail-box{
        min-width: auto;
        width: 5px;
        padding: 4px 0px;
      }
    }

  }
</style>
